//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    },
    vueApp: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      show: false,
      color: null,
      indicator: false
    };
  },
  watch: {
    "vueApp.indicator": function vueAppIndicator(val, oldVal) {
      if (this.indicator) {
        this.show = val;
      }
    }
  },
  methods: {
    $ready: function $ready() {
      var vm = this;
      this.$type.ifArray(this.spec.styleClasses, function (val) {
        ["success", "info", "error", "warning"].forEach(function (color) {
          if (val.includes(color)) {
            vm.color = vm.$vuetify.theme.currentTheme[color];
          }
        });
      });
    },
    click: function click(spec) {
      var onClick = spec["onClick"];
      this.show = false;
      GLib.action.execute(onClick, this);
    }
  }
};